import {Component, input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {VisitContext} from "../../../visit-details/visit-context";
import {ApiCustomer, CustomerLogItem, GetCustomerHistoryLog} from "@portbase/bezoekschip-service-typescriptmodels";
import {ComparatorChain} from "../../../common/comparator-chain";
import {sendQuery} from "../../../common/utils";

@Component({
  selector: 'app-release-to-party-history',
  templateUrl: './release-to-party-history.component.html',
  styleUrl: './release-to-party-history.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReleaseToPartyHistoryComponent implements OnInit {
  model = input<ApiCustomer>();

  context = VisitContext;
  items: CustomerLogItem[] = [];
  reverseOrder = true;

  private logComparator = new ComparatorChain("timestamp").compare;

  ngOnInit(): void {
    sendQuery("com.portbase.bezoekschip.common.api.commercialrelease.GetCustomerHistoryLog", <GetCustomerHistoryLog>{
      customerShortName: this.model().portbaseId,
      ownerShortName: this.model().ownerPortbaseId
    }, {showSpinner: true, caching: false})
      .subscribe((items: CustomerLogItem[]) => this.items = items.sort(this.logComparator));
  }

  cast = (item: CustomerLogItem): CustomerLogItem => item;

  toggleOrder() {
    this.reverseOrder = !this.reverseOrder;
  }
}
